<template>
  <svg class="svg-icon" aria-hidden="true" :style="getStyle">
    <use :xlink:href="`#${name}`"></use>
  </svg>
</template>

<script>
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String
    }
  },
  setup(props) {
    const getStyle = computed(() => {
      const { size, color } = props
      let s = `${size}`
      if (typeof size === 'number') s = `${size}px`
      return {
        width: s,
        height: s,
        color
      }
    })
    return { getStyle }
  }
})
</script>

<style>
.svg-icon {
  width: 2em;
  height: 2em;
  color: #222222;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
